/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page3_Table_MaxInputs */



/**
* | output |
* | --- |
* | "Max qty" |
*
* @param {Intervention_Plan_Pdf_Page3_Table_MaxInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page3_table_max = /** @type {((inputs?: Intervention_Plan_Pdf_Page3_Table_MaxInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page3_Table_MaxInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Max qty")
	return /** @type {LocalizedString} */ ("Quantite max")
});